<!-- eslint-disable vue/multi-word-component-names -->
<style>
a {
    cursor: pointer;
}
</style>

<template>
    <!-- footer -->
    <!-- footer -->
    <div class="footer">
        <!-- otherLink -->
        <div class="otherLink bg-pink-6">
            <ul>
                <li>
                    <a href="https://www.esunsec.com.tw/news/detail.aspx?id=9124" target="_blank">瀏覽器建議</a>
                </li>
                <li>
                    <a href="https://www.esunsec.com.tw/faq/detail.aspx?id=97CF60F90CC047C8A6A0D319A2F04925" target="_blank">常見問題</a>
                </li>
                <li>
                    <a href="https://www.esunsec.com.tw/about/announcement.aspx?id=4" target="_blank">個資法定告知事項</a>
                </li>
                <li>© E.SUN Securities</li>
            </ul>
        </div>
        <!-- otherLink -->
    </div>
    <!-- footer -->
    <!-- footer end-->
</template>
